export default "__VITE_ASSET__104225c6__"